require('./bootstrap');

document.addEventListener('DOMContentLoaded', () => {
    const body = document.body;
    const sidebarToggle = document.querySelector('[data-sidebar-toggle]');
    const sidebarBackdrop = document.querySelector('[data-sidebar-backdrop]');

    const closeSidebar = () => body.classList.remove('mp-sidebar-open');

    sidebarToggle?.addEventListener('click', () => {
        body.classList.toggle('mp-sidebar-open');
    });
    sidebarBackdrop?.addEventListener('click', closeSidebar);
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeSidebar();
    });

    document.querySelector('[data-group-select]')?.addEventListener('change', async (event) => {
        const select = event.currentTarget;
        select.disabled = true;

        try {
            const response = await fetch(select.dataset.endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.content ?? '',
                    'Accept': 'application/json',
                },
                body: JSON.stringify({ idGrupo: select.value }),
            });

            if (!response.ok) throw new Error('Falha ao trocar o grupo.');
            window.location.reload();
        } catch (error) {
            select.disabled = false;
            window.alert(error.message);
        }
    });
});
